import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Menu from '@/components/Menu/newMenu.vue'
  import Top from '@/components/Top/top.vue'
  import Bottom from '@/components/Bottom/bottom.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  // import Menu2 from '@/components/Menu/menu copy.vue'
  
return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Menu),
    _createVNode(Top),
    _createElementVNode("nav", null, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(Bottom)
  ], 64))
}
}

})